import {
	Button,
	ShowIcon,
	Modal,
	ModalBody,
	ModalFooter,
	Stack,
	ThemeSpaceVariable,
} from "@caspeco/casper-ui-library";
import usePasswordlessContext from "../hooks/passwordless/use-passwordless-context";
import { BiometricTypeEnum } from "../types/biometric-type-enum";
import { useUserContext } from "../hooks/use-user-context";
import EmptyState from "./empty-state";
import { useTranslation } from "react-i18next";
import { useAppContext } from "../hooks/use-app-context";

const PasswordlessModal = ({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) => {
	const { isSupport, isDeveloper } = useUserContext();
	const { setShowBiometricToast, biometricType, setPasswordlessOn, isLoading } = usePasswordlessContext();
	const { t } = useTranslation();
	const { safeArea } = useAppContext();

	const handleActivate = () => {
		setPasswordlessOn().then((success: boolean) => {
			if (success) {
				close();
			}
		});
	};

	const close = () => {
		setShowBiometricToast(false);
		onClose();
	};

	return (
		<Modal onClose={close} isOpen={isOpen && !isSupport && !isDeveloper} size="full">
			<ModalBody p={ThemeSpaceVariable.Large} mt={ThemeSpaceVariable.X2Large}>
				<EmptyState
					icon={ShowIcon}
					text={t("post_login_onboarding_pushnotofication_empty_description")}
					title={t("face_and_touchID")}
				/>
			</ModalBody>
			<ModalFooter pb={safeArea.bottomAsPx()}>
				<Stack
					w={"100%"}
					gap={ThemeSpaceVariable.Medium}
					p={ThemeSpaceVariable.Medium}
					pb={ThemeSpaceVariable.Large}
				>
					<Button
						variant={"primary"}
						isDisabled={biometricType === BiometricTypeEnum.None || isSupport || isDeveloper}
						onClick={handleActivate}
						isLoading={isLoading}
						size={"lg"}
					>
						{t("choice_activate")} {t("face_and_touchID")}
					</Button>
					<Button variant={"tertiary"} onClick={close} size={"lg"}>
						{t("choice_not_now")}
					</Button>
				</Stack>
			</ModalFooter>
		</Modal>
	);
};

export default PasswordlessModal;
